<template>
  <div class="primary">
    <Toast />
    <ConfirmPopup
      class="fixed w-[400px] top-[200px] left-0 right-0 mx-auto before:hidden after:hidden shadow-none rounded-[10px] !z-[1111]"></ConfirmPopup>
    <CreatePostModal
      v-if="userdata"
      v-model:isShow="isShow"
      is-close-active
      :main-title="'Compose'"
      :user-data="userdata">
    </CreatePostModal>
    <CreateOrgPostModal
      v-if="userdata"
      v-model:isShow="isShowOrgModal"
      is-close-active
      :main-title="'Compose'"
      :user-data="userdata">
    </CreateOrgPostModal>
    <Header />
    <div class="primary__inner grid">
      <Leftbar />
      <RouterView :key="$route.fullPath" class="primary__content px-[6px] sm:px-[0px] no-scroll" />
      <Rightbar v-if="!isMobile && $route.path !== '/search'" />
      <!-- <Rightbar v-if="false"/> -->
    </div>
  </div>
</template>

<script setup>
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';

import ConfirmPopup from 'primevue/confirmpopup';
import Toast from 'primevue/toast';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

import Header from '@/components/Header/index.vue';
import Leftbar from '@/components/Leftbar/index.vue';
import Rightbar from '@/components/Rightbar/index.vue';
import { debounce } from '@/utils/debounce.js';

import AboutUs from '../components/AboutUs/index.vue';
import CreatePostModal from '../components/modals/createPostModal.vue';
import CreateOrgPostModal from '../components/modals/OrgModals/createPostOrg.vue';
import { useToast } from 'primevue/usetoast';
const store = useStore();
const toast = useToast();
const router = useRouter();
const isMobile = ref(false);
const isShow = computed(() => store.getters.getShowModalStatus);
const isShowOrgModal = computed(() => store.getters.getOrgShowModalStatus);
const isShowReply = computed(() => store.getters.getShowModalReplyStatus);
const userdata = computed(() => store.getters.getUser);
const checkIfMobile = () => (isMobile.value = window.innerWidth <= 1024);
const debouncedCheckIfMobile = debounce(checkIfMobile, 100);

onMounted(async () => {
  checkIfMobile();
  window.addEventListener('resize', debouncedCheckIfMobile);
});
onBeforeUnmount(() => {
  window.removeEventListener('resize', debouncedCheckIfMobile);
});
</script>

<style lang="scss">
.primary {
  margin: 0 auto;
  background: var(--background-primary);
  max-width: 1280px;
  min-height: 100vh;
  // display: flex;
  // flex-direction: column;
  &__content {
    flex-grow: 1;
  }
  &__inner {
    grid-template-columns: 177px 1fr 278px;
    padding-top: 80px;
  }
  @include _1300 {
    &__inner {
      padding-right: 20px;
    }
  }
  @include _1279 {
    &__inner {
      grid-template-columns: 120px 1fr 278px;
      padding: 64px 48px 0;
    }
  }
  @include _1024 {
    &__inner {
      grid-template-columns: 116px 1fr;
      padding: 64px 0 0;
    }
  }
  @include _810 {
    &__inner {
      grid-template-columns: 118px 1fr;
    }
  }
  @include _767 {
    &__inner {
      grid-template-columns: 120px 1fr;
    }
  }
  @include _639 {
    &__inner {
      grid-template-columns: 1fr;
      padding-top: 64px;
      padding-bottom: 80px;
    }
  }
}
.p-toast {
  position: fixed !important;
  top: 30px !important;
  left: 0 !important;
  right: 0 !important;
  margin-left: auto !important;
  margin-right: auto !important;
  max-width: 100%;
  z-index: 2000 !important;
}
.wrap-confirm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: table;
}
</style>
